module.exports = __webpack_public_path__ + "static/media/4z3_website_logo_sup_tiet.5a27a1d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4z3_website_logo_sup_tiet.jpg
// module id = 81
// module chunks = 0